import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Materials/CreateDialog';
import { Material } from '@/models/Material';

@Component<Materials>({
  components: {
    CreateDialog,
  },
})
export default class Materials extends Vue {
  protected selectedMaterial: Material | null = null;

  protected isCreatingMaterial: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Material(),
      name: {
        singular: 'Material',
        plural: 'Materials',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, Material: Material) => {
            this.selectedMaterial = Material;
            this.isCreatingMaterial = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, Material: Material) => {
            this.selectedMaterial = Material;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingMaterial = true;
      }
    };
  }

  protected get MaterialsDatatable(): DataTable|null {
    const dataTable = this.$refs.MaterialsDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedMaterial as Material).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this material?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedMaterial) {
              return;
            }

            this.selectedMaterial
              .delete()
              .then((response: any) => {
                if (response) {
                  this.MaterialsDatatable ? this.MaterialsDatatable.refresh(true) : null;
                  this.selectedMaterial = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedMaterial = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingMaterial')
  protected isCreatingMaterialChanged() {
    if(!this.isCreatingMaterial) {
      this.selectedMaterial = null;
    }
  }
}
